import api from '../api';

import { ParamsBodyPostCreateLoginApp } from 'utils/typeServices';

type ParamsResponse = {
    Data: {
        CadastradoComSucesso: boolean;
        expires_in: number;
        token: string;
        errorMsg?: string;
    };
}

export const PostCreateLoginApp = async (body: ParamsBodyPostCreateLoginApp) => {
    const bodyContacts = JSON.stringify({
        Alias: body.Alias,
        Zipcode: body.Zipcode,
        Plate: body.Plate,
        Chassi: body.Chassi,
        Document: body.Document,
        Email: body.Email,
        Password: body.Password,
        ConfirmPassword: body.ConfirmPassword,
        Token: body.Token
    });

    try {
        const { data } = await api.post<ParamsResponse>('/v1/Cliente/CreateLoginApp', bodyContacts);

        return data.Data;
    } catch (error) {
        return {
            CadastradoComSucesso: false,
            expires_in: 0,
            token: '',
            // @ts-ignore
            errorMsg: error?.response?.data?.Data || '',
        };
    }
}